<template>
  <v-dialog
    v-model="dialog"
    width="500px"
    style="z-index: 9999;"
  >
    <v-card>
      <v-toolbar dense elevation="0">
        <v-toolbar-title>{{ $t("dialog.vehicle_selection.title") }}</v-toolbar-title>
        <div class="flex-grow-1"></div>
        <v-text-field
          :label="$t('dialog.vehicle_selection.filter')"
          v-model="vehicleFilter"
          autofocus
          solo
          flat
          hide-details
          prepend-inner-icon="mdi-filter"
          style="width: 40px"
        ></v-text-field>
        <v-btn icon @click="dialog=false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider class="mx-2" />

      <v-virtual-scroll ref="vscroll" :items="filteredVehicles" bench="1064" min-height="104px" max-height="50vh"
                        item-height="64">
        <template v-slot:default="{ item }">
          <v-list-item :key="item.vehicleId" @click="vehicleSelect(item)">
            <v-list-item-content>
              <v-list-item-title>
                <span class="font-weight-bold pr-2">{{ item.numericPlate }}</span>
                <v-icon v-if="getVehicleIcon(item) === 'navigation'" small :class="getVehicleIconColor(item)"
                        :style="getStyleRotate(item) + ';margin: 0'">navigation
                </v-icon>
                <v-icon v-else-if="getVehicleIcon(item) === 'circle'" x-small :class="getVehicleIconColor(item)"
                        style="padding-bottom: 2px">circle
                </v-icon>
                <v-icon v-else x-small :class="getVehicleIconColor(item)" style="padding-bottom: 2px">square</v-icon>
                <span class="pl-2 grey--text">{{ item.name }}</span>
              </v-list-item-title>
              <v-list-item-subtitle class="list-item-subtitle">
                  <span
                    v-if="item.termService === 'notice' || item.termService === 'warning' || item.termMot === 'notice' || item.termMot === 'warning' || item.termTachographCheck === 'notice' || item.termTachographCheck === 'warning'">
                    <span v-if="item.termService === 'notice' || item.termService === 'warning'">
                      <span :class="'service_' + item.termService">{{ $t("map.panel.online.service") }}</span>
                    </span>
                    <span v-if="item.termMot === 'notice' || item.termMot === 'warning'">
                      <span :class="'service_' + item.termMot">STK</span>
                    </span>
                    <span v-if="item.termTachographCheck === 'notice' || item.termTachographCheck === 'warning'">
                      <span :class="'service_' + item.termTachographCheck">T</span>
                    </span>
                    <span class="grey--text">&nbsp;•&nbsp;</span>
                  </span>
                <template v-if="item.ride !== null">
                    <span v-if="isDriver(item)">{{ getDriver(item) }}<span
                      class="grey--text">&nbsp;•&nbsp;</span></span>
                  <span class="font-italic">{{ $t("enum.ride_type." + item.ride.rideType) }}</span>
                </template>
                <span v-else>-</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-virtual-scroll>
    </v-card>
  </v-dialog>
</template>

<script>

import utils from "@/utils";

export default {
  name: "VehicleSelectionDialog",

  data() {
    return {
      dialog: false,
      vehicleFilter: null
    };
  },

  methods: {
    open() {
      this.vehicleFilter = null;
      this.dialog = true;

      this.$nextTick().then(() => {
        this.$refs.vscroll.$el.scrollTop = 1;
        this.$refs.vscroll.$el.scrollTop = 0;
      });
    },

    vehicleSelect(item) {
      this.$emit("selected", item);
      this.dialog = false;
    },

    getVehicleIconColor(vehicle) {
      switch (utils.vehicleState(vehicle)) {
        case "ACTIVE":
          if (vehicle.ride !== null && vehicle.ride.rideState === "unfinished")
            return "blue--text";
          else
            return "";
        case "NEW":
          return "blue-grey--text text--lighten-2";
        default:
          return "red--text text--lighten-2";
      }
    },

    getStyleRotate(vehicle) {
      return "transform: rotate(" + vehicle.location.direction + "deg)";
    },

    getVehicleIcon(vehicle) {
      if (vehicle.ride !== null && vehicle.ride.rideState === "unfinished") {
        if (vehicle.location.speed >= 5) {
          return "navigation";
        } else {
          return "circle";
        }
      } else {
        return "square";
      }
    },

    getDriver(vehicle) {
      if (this.isDriver(vehicle)) {
        if (vehicle.ride.driver !== null)
          return vehicle.ride.driver.firstName + " " + vehicle.ride.driver.lastName;
        else if (vehicle.ride.driverCode !== null)
          return vehicle.ride.driverCode;
      }

      return "";
    },

    isDriver(vehicle) {
      return vehicle.ride !== null && (vehicle.ride.driver !== null || (vehicle.ride.driverIdentification !== null && vehicle.ride.driverCode !== null));
    },

    keyEvent(keyEvent) {
      if (!this.dialog)
        return;

      if (keyEvent.key === "Enter") {
        const list = this.filteredVehicles;

        if (list.length === 1)
          this.vehicleSelect(list[0]);
      }
    }
  },

  watch: {
    dialog(newValue) {
      if (newValue === false)
        this.$store.dispatch("dialogs/hideDialog", "vehicleSelection");
    }
  },

  computed: {
    filteredVehicles() {
      if (this.vehicleFilter != null) {
        const filter = this.vehicleFilter.toLowerCase();
        return this.$store.state.online.vehicles.filter(
          x => x.numericPlate.toLowerCase().includes(filter)
            || x.name.toLowerCase().includes(filter)
            || (x.ride && x.ride.driver && (
              x.ride.driver.lastName && x.ride.driver.lastName.toLowerCase().includes(filter)
              || x.ride.driver.firstName && x.ride.driver.firstName.toLowerCase().includes(filter))));
      } else
        return this.$store.state.online.vehicles;
    }
  },

  mounted() {
    document.addEventListener("keydown", this.keyEvent);
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.keyEvent);
  }
};
</script>

<style lang="sass" scoped>
.list-item-subtitle
  padding: 3px 1px 0 0 !important
  font-size-adjust: 0.48

.service_notice
  background-color: grey
  color: white
  padding: 1px 6px
  margin: 0 1px
  border-radius: 7px
  font-size: 90%

.service_warning
  background-color: #c06432
  color: white
  padding: 1px 6px
  margin: 0 1px
  border-radius: 7px
  font-size: 90%
</style>